module.exports = __webpack_public_path__ + "static/img/enter-icon.23dde1dc.svg";